import {AbstractResource} from 'vue3-starter/src/typescript/resource/AbstractResource';
import * as RawModel from '@/common/api/api-raw-types';

export class SelectedFreelancerResource extends AbstractResource {
    avgAnsweringTime?: string;
    firstName: string;
    fullName: string;
    headline?: string;
    lastName: string;
    malterLevels: RawModel.MalterLevel[];
    photo?: RawModel.PhotoView;
    price?: RawModel.PriceView;
    profileId: string;
    recommendationsCount: number;
    ratings: number;
    preferredCategory?: string;

    constructor(rawData: RawModel.SelectedFreelancerResource) {
        super(rawData);
        this.avgAnsweringTime = rawData.avgAnsweringTime;
        this.firstName = rawData.firstName;
        this.fullName = rawData.fullName;
        this.headline = rawData.headline;
        this.lastName = rawData.lastName;
        this.malterLevels = rawData.malterLevels;
        this.profileId = rawData.profileId;
        this.price = rawData.price;
        this.photo = rawData.photo;
        this.recommendationsCount = rawData.recommendationsCount;
        this.ratings = rawData.ratings;
        this.preferredCategory = rawData.preferredCategory;
    }

    get photoUrl(): string | null {
        return this.photo ? `${this.photo.baseUrl}/${this.photo.name}` : null;
    }

    get isRepatriation(): boolean {
        return this.price?.details?.fees.type === 'REPATRIATION';
    }
}
